// Generated by CoffeeScript 1.12.6
exports.statuses = ['new', 'submitted', 'confirmed', 'closed', 'cancelled'];

exports.foodhubSlug = ['sfbay', 'nola', 'nyc', 'la'];

exports.lineItemStatus = ['new', 'submitted', 'confirmed', 'closed', 'cancelled', 'edited'];

exports.terminalStatuses = ['closed', 'cancelled', 'edited'];

exports.lineItemTypes = ['product', 'deliveryFee', 'packagingDeposit'];

exports.purchaseOrderStatus = ['new', 'submitted', 'confirmed', 'closed', 'cancelled'];

exports.lineItemSellability = ['received', 'confirmed (delivery day)', 'confirmed (day after delivery day)', 'confirmed (2 days after delivery day)', 'confirmed (3 days after delivery day)'];

exports.orderTypes = ['just-in-time', 'wholesale', 'consignment'];

exports.unitTypes = ['container', 'weight', 'each'];

exports.activeDropoffWindows = ['12am-2am', '1am-3am', '2am-4am', '3am-5am', '4am-6am', '5am-7am', '6am-8am', '7am-9am', '8am-10am', '9am-11am', '10am-12pm', '11am-1pm', '12pm-2pm', '1pm-3pm', '2pm-4pm', '3pm-5pm', '4pm-6pm', '5pm-7pm', '6pm-8pm', '7pm-9pm', '8pm-10pm', '9pm-11pm', '10pm-12am', 'third-party-carrier'];

exports.defaultDropoffWindow = '6am-8am';

exports.dropoffWindows = exports.activeDropoffWindows.concat(['6am-9am', '730am-930am', '730am-10am', '12pm-7pm', '1pm-4pm', '3pm-6pm', '3pm-7pm', '4pm-7pm', '5pm-730pm', 'backhaul']);

exports.sameDayAvailabilityCutoff = {
  hours: 7,
  minutes: 1
};
